import { render } from "./SinglePair.vue?vue&type=template&id=6373c412"
import script from "./SinglePair.vue?vue&type=script&lang=js"
export * from "./SinglePair.vue?vue&type=script&lang=js"

import "./SinglePair.vue?vue&type=style&index=0&id=6373c412&lang=css"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__